import type { BookmarkType } from "@circle-react/types/Bookmarks";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

interface NoBookmarksProps {
  activeTab: BookmarkType;
}

export const NoBookmarks = ({ activeTab }: NoBookmarksProps) => (
  <div className="flex min-h-[50dvh] flex-1 flex-col items-center justify-center px-6 lg:min-h-0">
    <div className="flex flex-col items-center gap-3 text-center">
      <Typography variant="heading-lg">
        {t(`header_v3.no_bookmarks_by_type.${activeTab}`)}
      </Typography>
      <Typography variant="body-md" color="secondary">
        {t(`header_v3.no_bookmarks_description_by_type.${activeTab}`)}
      </Typography>
    </div>
  </div>
);
